export default "__VITE_ASSET__b0UokH1A__"